import state from './logsState'
import mutations from './logsMutations'
import getters from './logsGetters'
import actions from './logsActions'

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
}
